export default {
  apiKey: "AIzaSyAAc0gGsiUohodAjRpglFrSRFaKmMRvM1c",
  authDomain: "kmiou-because-mturk005.firebaseapp.com",
  databaseURL: "https://kmiou-because-mturk005-default-rtdb.firebaseio.com",
  projectId: "kmiou-because-mturk005",
  storageBucket: "kmiou-because-mturk005.appspot.com",
  messagingSenderId: "913244735652",
  appId: "1:913244735652:web:687f793aea44edceeb7e31"
};